﻿export class CreateWorkItemRequested {
    constructor(public hash:string, public closeWhenComplete: boolean) { }

    static eventName() { return 'CreateWorkItemRequested'; }

    eventName = CreateWorkItemRequested.eventName;
}